import React, { FC } from 'react';
import PrimaryNavigation from '../../components/core/PrimaryNavigation/PrimaryNavigation';
import styles from './AdminRepositoryRequest';
import ListAdminRepositoryRequest from '../../components/core/AdminRequestRepository/AdminRequestRepository';
interface AdminRepositoryRequestProps {}

const  AdminRepositoryRequest: FC<AdminRepositoryRequestProps> = () => (
  <div className=" AdminRepositoryRequest">
          <PrimaryNavigation />
          <div className="container-repository-request">
         <ListAdminRepositoryRequest></ListAdminRepositoryRequest>
          </div>
      </div>
);

export default AdminRepositoryRequest;